/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Checkbox,
  FormControl,
  InputLabel,
  TextField,
  FormControlLabel,
  Button, Switch
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { additionalSubscriptionInfoFormValidation } from '../../../utils/validationSchema'
import { FormLoader } from '../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'
import { ButtonLoader } from '../../Loader/ButtonLoader'
import { NamedRoutes } from '../../../routes'
import { useHistory } from 'react-router-dom'
import { useStyles } from './Styles'

const AdditionalSubscriptionInfo = ({ userData, roles, submitForm, updateProfileSuccess, updateProfileFailure, forUsers }) => {
  const classes = useStyles()
  const intl = useIntl()
  const history = useHistory()
  const additionalInfoForm = useFormik({
    initialValues: {
      active: userData.active || false,
      roles: userData.rolesIds || []
    },
    validateOnBlur: false,
    validateOnChange: true,
    validationSchema: additionalSubscriptionInfoFormValidation,
    onSubmit: ((values, actions) => {
      submitForm(values, actions)
    })
  })

  const [activeValue, setActiveValue] = React.useState(additionalInfoForm.values.active)
  const handleActiveChange = (event) => {
    setActiveValue(!JSON.parse(event.target.value))
    additionalInfoForm.setFieldValue('active', !JSON.parse(event.target.value))
  }

  const [rolesValue, setRolesValue] = React.useState(roles.filter((role) => additionalInfoForm.values.roles.includes(role.id)))

  return (
    <form onSubmit={additionalInfoForm.handleSubmit} noValidate autoComplete="off"
          className={classes.formWrapper}>
      {!!updateProfileFailure &&
      <Alert severity="error"><FormattedMessage id='UpdateProfile.FormErrorAlert'/></Alert>
      }
      {!!updateProfileSuccess &&
      <Alert severity="success"><FormattedMessage
        id={!!forUsers ? 'UserUpdateProfile.FormSuccessAlert' : 'UpdateProfile.FormSuccessAlert'}/></Alert>
      }

      <div className={classes.AdditionalInfoRow}>
        <InputLabel id="AdditionalInfo.roles"><FormattedMessage id='Fields.label.Roles'/></InputLabel>
        <Autocomplete
          multiple
          id="AdditionalInfo.Roles"
          loading={!roles}
          loadingText={<ButtonLoader loading={true}/>}
          options={roles || []}
          value={rolesValue}
          freeSolo
          disableCloseOnSelect
          getOptionLabel={(option) => option.name}
          onChange={(event, value) => {
            setRolesValue(value)
            let rolesIds = (!!value && !!value.length) ?
              value.map(role => role.id) : []
            additionalInfoForm.setFieldTouched('roles', true, true)
            additionalInfoForm.setFieldValue('roles', rolesIds)
          }}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                color={'primary'}
                checked={additionalInfoForm.values.roles.includes(option.id)}
              />
              {option.name}
            </React.Fragment>
          )}
          renderInput={(params) => (
            <TextField {...params} variant="outlined"
                       placeholder={intl.formatMessage({ id: 'AdditionalInfo.placeholder.Roles' })}
                       name='roles'
                       onChange={additionalInfoForm.handleChange}
                       onBlur={additionalInfoForm.handleBlur}
                       helperText={additionalInfoForm.errors.roles && additionalInfoForm.touched.roles && additionalInfoForm.errors.roles}
                       error={additionalInfoForm.errors.roles && additionalInfoForm.touched.roles !== undefined}
            />
          )}
        />
      </div>


      <div className={classes.AdditionalInfoRow}>
        <InputLabel id="AdditionalInfo.Active"><FormattedMessage
          id='Users.List.Table.Active'/>:</InputLabel>
        <FormControl variant="outlined" className={classes.SwitchWrapper}>
          <FormControlLabel
            label={activeValue ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })}
            value={activeValue ? true : false}
            control={
              <Switch color="primary" checked={activeValue} value={activeValue ? true : false}/>
            }
            onChange={handleActiveChange}
          />
        </FormControl>
      </div>

      <div className={classes.SubmitRow}>
        <button type="submit" disabled={additionalInfoForm.isSubmitting}
                className={classes.AdditionalInfoSubmit}>
          <FormattedMessage id='AdditionalInfo.button.submit'/>
        </button>
        <Button onClick={() => history.push(NamedRoutes.subscription.user.list)} color="primary">
          <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
        </Button>
      </div>
      {additionalInfoForm.isSubmitting && <FormLoader loading={true}/>}
    </form>
  )
}

export default AdditionalSubscriptionInfo
